
import { Assessment, Category } from '@/types/assessment';

/**
 * Process detailed information about answers for more context in results
 */
export const processDetailedAnswers = (
  responses: Record<string, any>,
  categories: Category[]
) => {
  const answerDetails: Record<string, any> = {};
  
  // Process each response
  Object.entries(responses).forEach(([questionId, response]) => {
    // Find the question and category for this response
    let foundQuestion;
    let foundCategory;
    
    for (const category of categories) {
      const question = category.questions.find(q => q.id === questionId);
      if (question) {
        foundQuestion = question;
        foundCategory = category;
        break;
      }
    }
    
    if (!foundQuestion || !foundCategory) return;
    
    // Process current value
    let currentDetails = null;
    if (typeof response.current === 'number') {
      // For slider or maturity questions
      currentDetails = {
        value: response.current
      };
    } else if (Array.isArray(response.current) && response.current.length > 0) {
      // For single/multiple choice questions
      const answerId = response.current[0];
      const answer = foundQuestion.answers.find(a => a.id === answerId);
      if (answer) {
        currentDetails = {
          id: answer.id,
          text: answer.text,
          value: answer.value
        };
      }
    }
    
    // Process target value
    let targetDetails = null;
    if (typeof response.target === 'number') {
      // For slider or maturity questions
      targetDetails = {
        value: response.target
      };
    } else if (Array.isArray(response.target) && response.target.length > 0) {
      // For single/multiple choice questions
      const answerId = response.target[0];
      const answer = foundQuestion.answers.find(a => a.id === answerId);
      if (answer) {
        targetDetails = {
          id: answer.id,
          text: answer.text,
          value: answer.value
        };
      }
    }
    
    // Add answer details to the collection
    answerDetails[questionId] = {
      questionId,
      categoryId: foundCategory.id,
      questionText: foundQuestion.text,
      current: currentDetails,
      target: targetDetails
    };
  });
  
  return answerDetails;
};
